import { useEffect } from "react";
import { isAndroid } from "react-device-detect";
import { getIsIOSDevice } from "@/shared/utils/device-detect";

const useAddHTMLClassNameIsIOSDevice = () => {
  useEffect(() => {
    if (getIsIOSDevice()) {
      document.documentElement.classList.add("is-ios-device");
    }
  }, []);
};

const useAddHTMLClassNameIsAndroidDevice = () => {
  useEffect(() => {
    if (isAndroid) {
      document.documentElement.classList.add("is-android");
    }
  }, []);
};

const useGlobalClassNameDeviceOS = () => {
  useAddHTMLClassNameIsIOSDevice();
  useAddHTMLClassNameIsAndroidDevice();
};

export default useGlobalClassNameDeviceOS;
